import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ParentsAttendingPTMsAndCYRCEvents = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Parents attending PTMs and CYRC events (%)" />
    </Box>
  );
};
